import PreloadedAnimation from "../../app/PreloadedAnimation";
import store from "../../app/store";


class RadarAnimation extends PreloadedAnimation{

    constructor(layer) {
        super(layer);
        this.timeFrame = 75;
    }

    getTimeRange(){
        return store.get("radarRange");
    }

    getCalendar(){
        return store.get("radarCalendar");
    }

    getTimestamp(){
        return store.get("radarTimestamp");
    }

    setTimestamp(timestamp){
        return store.set("radarTimestamp", timestamp);
    }


}

export default RadarAnimation;
